<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t("components.userForm.title") }}</span>
          </div>
          <h2></h2>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <ControlAccessCardForm></ControlAccessCardForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ControlAccessCardForm from '@/components/ControlAccessCardForm.vue';

export default {
  name: 'ControlAccessCard',
  components: {
    ControlAccessCardForm
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  }
};
</script>
